// DS1.7.11
import React from 'react';
import c from 'classnames';
import HexagonLocked16 from './Hexagon/16x16/Locked';
import HexagonUnlocked16 from './Hexagon/16x16/Unlocked';
import HexagonLocked24 from './Hexagon/24x24/Locked';
import HexagonUnlocked24 from './Hexagon/24x24/Unlocked';
import HexagonLocked32 from './Hexagon/32x32/Locked';
import HexagonUnlocked32 from './Hexagon/32x32/Unlocked';
import HexagonLocked40 from './Hexagon/40x40/Locked';
import HexagonUnlocked40 from './Hexagon/40x40/Unlocked';
import Tier16 from './Tier/16x16';
import Tier24 from './Tier/24x24';
import Tier32 from './Tier/32x32';
import Tier40 from './Tier/40x40';
import Adoptable16 from './Adoptable/16x16';
import Adoptable24 from './Adoptable/24x24';
import Adoptable32 from './Adoptable/32x32';
import Adoptable40 from './Adoptable/40x40';
import Commission16 from './Commission/16x16';
import Commission24 from './Commission/24x24';
import Commission32 from './Commission/32x32';
import Commission40 from './Commission/40x40';
import PremiumGallery16 from './PremiumGallery/16x16';
import PremiumGallery24 from './PremiumGallery/24x24';
import PremiumGallery32 from './PremiumGallery/32x32';
import PremiumGallery40 from './PremiumGallery/40x40';
import PremiumDownload16 from './PremiumDownload/16x16';
import PremiumDownload24 from './PremiumDownload/24x24';
import PremiumDownload32 from './PremiumDownload/32x32';
import PremiumDownload40 from './PremiumDownload/40x40';
import Generic16 from './Generic/16x16';
import Generic24 from './Generic/24x24';
import Generic32 from './Generic/32x32';
import Generic40 from './Generic/40x40';

import s from './PromoBadge.scss';

export interface Props {
  badgeType: 'tier' | 'commission' | 'adoptable' | 'premium_gallery' | 'pcp' | 'generic';
  size: 16 | 24 | 32 | 40;
  isLocked?: boolean;
  className?: string;
  useSecondaryColor?: boolean;
}

const lockedHexagonSizes = {
  16: HexagonLocked16,
  24: HexagonLocked24,
  32: HexagonLocked32,
  40: HexagonLocked40,
};
const unlockedHexagonSizes = {
  16: HexagonUnlocked16,
  24: HexagonUnlocked24,
  32: HexagonUnlocked32,
  40: HexagonUnlocked40,
};

const TierIcon = {
  16: Tier16,
  24: Tier24,
  32: Tier32,
  40: Tier40,
};

const AdoptableIcon = {
  16: Adoptable16,
  24: Adoptable24,
  32: Adoptable32,
  40: Adoptable40,
};

const CommissionIcon = {
  16: Commission16,
  24: Commission24,
  32: Commission32,
  40: Commission40,
};

const PremiumGalleryIcon = {
  16: PremiumGallery16,
  24: PremiumGallery24,
  32: PremiumGallery32,
  40: PremiumGallery40,
};

const PremiumDownloadIcon = {
  16: PremiumDownload16,
  24: PremiumDownload24,
  32: PremiumDownload32,
  40: PremiumDownload40,
};

const GenericIcon = {
  16: Generic16,
  24: Generic24,
  32: Generic32,
  40: Generic40,
};

const PromoBadge: React.FC<Props> = ({
  badgeType,
  size,
  isLocked,
  className,
  useSecondaryColor,
}) => {
  const BackgroundComponent = isLocked ? lockedHexagonSizes[size] : unlockedHexagonSizes[size];
  const IconComponent = {
    tier: TierIcon[size],
    commission: CommissionIcon[size],
    premium_gallery: PremiumGalleryIcon[size],
    adoptable: AdoptableIcon[size],
    pcp: PremiumDownloadIcon[size],
    generic: GenericIcon[size],
  }[badgeType];

  return (
    <div
      className={c(
        s['root'],
        s[`type-${badgeType}`],
        isLocked && s['locked'],
        s[`size-${size}`],
        className
      )}
    >
      <BackgroundComponent
        className={c(s['background'], useSecondaryColor && s['secondary-color'])}
      />
      <IconComponent className={s['icon']} />
    </div>
  );
};
PromoBadge.displayName = 'PromoBadge';

export default PromoBadge;
